import { ProductCategory, ProductCategoryResource } from '../../@products/ProductCategory/ProductCategory';
import { DefaultBlock, DefaultBlockResource } from '../../Block/Block';

export enum CategorySliderTypeResource {
    lineImage = 'Lijntekening',
    defaultImage = 'Foto',
}

export interface CategorySliderResource extends DefaultBlockResource {
    title: string | null;
    layout: CategorySliderTypeResource;
    categories: ProductCategoryResource[];
}

export interface CategorySliderInterface extends DefaultBlock {
    title?: string;
    categories: ProductCategory[];
}
